import { render, staticRenderFns } from "./OpenPermissionRequests.vue?vue&type=template&id=2c1d6bc1&scoped=true"
import script from "./OpenPermissionRequests.vue?vue&type=script&lang=js"
export * from "./OpenPermissionRequests.vue?vue&type=script&lang=js"
import style0 from "./OpenPermissionRequests.vue?vue&type=style&index=0&id=2c1d6bc1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1d6bc1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c1d6bc1')) {
      api.createRecord('2c1d6bc1', component.options)
    } else {
      api.reload('2c1d6bc1', component.options)
    }
    module.hot.accept("./OpenPermissionRequests.vue?vue&type=template&id=2c1d6bc1&scoped=true", function () {
      api.rerender('2c1d6bc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/OpenPermissionRequests.vue"
export default component.exports